import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import Background from "../../../../assets/images/welcome-background.webp";
import signboards from "../../../../assets/images/signboards.webp";
import { useTranslation } from "react-i18next";
import { isBrowserDefined } from "../../../../shared/services/browserService";

const WelcomeSection: React.FC = () => {
  const { t } = useTranslation();
  const titleRef = useRef<HTMLHeadingElement>(null);
  const descriptionRef = useRef<HTMLParagraphElement>(null);
  const moreRef = useRef<HTMLButtonElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const badgeRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        defaults: {
          ease: "power2.out",
          willReadFrequently: false,
        },
      });

      tl.fromTo(
        titleRef.current,
        {
          y: 50,
          opacity: 0,
          willChange: "transform, opacity",
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          clearProps: "willChange",
        },
      )
        .fromTo(
          descriptionRef.current,
          {
            y: 30,
            opacity: 0,
            willChange: "transform, opacity",
          },
          {
            y: 0,
            opacity: 1,
            duration: 0.8,
            clearProps: "willChange",
          },
          "-=0.3",
        )
        .fromTo(
          moreRef.current,
          {
            y: 20,
            opacity: 0,
            willChange: "transform, opacity",
          },
          {
            y: 0,
            opacity: 1,
            duration: 0.6,
            clearProps: "willChange",
          },
          "-=0.3",
        );
    }, containerRef);

    return () => ctx.revert();
  }, []);

  const scrollToAbout = () => {
    if (isBrowserDefined()) {
      const aboutSection = document.getElementById("about-section");
      if (aboutSection) {
        aboutSection.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <div ref={containerRef} className="relative h-screen">
      <img
        src={Background}
        alt="Welcome"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black opacity-10"></div>
      {/* Badge */}
      <div
        ref={badgeRef}
        className="flex items-center justify-end absolute top-2/3 right-0 lg:right-10  -translate-y-1/2 z-2"
      >
        <img src={signboards} alt="More" className="w-[40%] h-100 lg:w-80" />
      </div>
      <div className="absolute top-0 left-0 w-full h-full flex flex-col items-start lg:pt-[80px] justify-center px-[6%] md:px-20 lg:px-20 xl:px-20"></div>
    </div>
  );
};

export default WelcomeSection;
